module.exports = __webpack_public_path__ + "static/media/link-arr.e21ea57b.svg";